/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GameMoneyInvoice = {
    id?: string;
    /**
     * User ID who created the invoice
     */
    userId?: string;
    /**
     * Invoice amount in cents
     */
    amount?: number;
    /**
     * Invoice status: 0=Pending, 1=Paid, 2=Cancelled, 3=Expired
     */
    status?: GameMoneyInvoice.status;
    /**
     * GameMoney invoice ID
     */
    invoiceId?: string;
    /**
     * Payment URL
     */
    url?: string;
    createdAt?: string;
    updatedAt?: string;
};
export namespace GameMoneyInvoice {
    /**
     * Invoice status: 0=Pending, 1=Paid, 2=Cancelled, 3=Expired
     */
    export enum status {
        '_0' = 0,
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
    }
}

